var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-flex", { attrs: { xs12: "" } }, [
    _c(
      "div",
      [
        _c(
          "v-layout",
          { attrs: { row: "", wrap: "" } },
          [
            _c(
              "v-flex",
              { attrs: { xs10: "", "offset-xs1": "" } },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              { staticClass: "py-0" },
                              [
                                _c("v-skeleton-loader", {
                                  staticClass: "px-4",
                                  attrs: {
                                    type: "heading",
                                    "max-width": "400",
                                  },
                                }),
                                _c("v-skeleton-loader", {
                                  staticClass: "px-4 pt-6",
                                  attrs: { type: "text", "max-width": "400" },
                                }),
                                _c("v-skeleton-loader", {
                                  staticClass: "px-4",
                                  attrs: { type: "text", "max-width": "350" },
                                }),
                                _c("v-skeleton-loader", {
                                  staticClass: "px-4",
                                  attrs: { type: "text", "max-width": "300" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs10: "", "offset-xs1": "" } },
              [
                _c("v-skeleton-loader", {
                  staticClass: "py-5",
                  attrs: { type: "heading", "max-width": "600" },
                }),
                _c(
                  "v-card",
                  [
                    _c(
                      "v-list",
                      { style: { padding: "0" }, attrs: { "two-line": "" } },
                      _vm._l(12, function (i) {
                        return _c(
                          "div",
                          { key: i },
                          [
                            _c("v-divider"),
                            _c(
                              "div",
                              { staticStyle: { padding: "10px" } },
                              [
                                _c("v-skeleton-loader", {
                                  attrs: { type: "text" },
                                }),
                                _c("v-skeleton-loader", {
                                  attrs: {
                                    type: "table-tbody",
                                    "max-height": "50",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }